import styled from "styled-components";

export const HeaderWrapper = styled.div`
  overflow: visible;
  background-image: url(${(props) => props.bg});
  background-repeat: no-repeat;
  background-size: cover;
  @media (max-width: 768px) {
    background-size: 200% auto;
  }

  /* Any page with a hero: the header runs to just above the fold (90px on
     desktop, 27px on phones) and the hero takes whatever the top bar and
     navbar leave; its image overhangs that last strip, so it ends exactly at
     the bottom of the screen. svh keeps phones steady as the URL bar moves. */
  &.header--full {
    display: flex;
    flex-direction: column;
    min-height: calc(100vh - 90px);
    & > .hero {
      flex: 1 1 auto;
    }
    @media (max-width: 768px) {
      min-height: calc(100vh - 27px);
      min-height: calc(100svh - 27px);
      & > .video-player {
        flex: 1 1 auto;
        display: flex;
        iframe {
          height: auto;
          min-height: 32vh;
        }
      }
    }
  }
`;
